module.exports = __webpack_public_path__ + "img/Alexcoutcharmtable51.e9cf53fd.jpg";